import clsx from 'clsx';

import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import { pipeRackLeft, pipeRackRight } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  workOrderAsset: any;
}

const PipeRackData = ({ workOrderAsset }: Props) => {
  const dataLeft = getAttributeDataRows(
    workOrderAsset?.attributes,
    pipeRackLeft,
  );

  const dataRight = getAttributeDataRows(
    workOrderAsset?.attributes,
    pipeRackRight,
  );

  return (
    <div className={clsx(classes.sectionBox, classes.noMargin)}>
      <div className={classes.sectionTitle}>Pipe Rack Data</div>
      <div className={classes.inspectionContent}>
        <div className={classes.leftBox}>
          {dataLeft.map(attribute => {
            return (
              <div className={classes.dataRow} key={attribute?.id}>
                <div className={classes.dataTitle}>{`${attribute?.name}:`}</div>
                <div className={classes.dataContent}>
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className={classes.rightBox}>
          {dataRight.map(attribute => {
            return (
              <div className={classes.dataRow} key={attribute?.id}>
                <div className={classes.dataTitle}>{`${attribute?.name}:`}</div>
                <div className={classes.dataContent}>
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PipeRackData;
